import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {UserModelResponse, UserRequests} from "@/app/api/user";
import {AppThunk} from "@/app/store";
import {useAppSelector} from "@/app/hooks";
import {useNavigate} from "react-router-dom";

export const HomeScreenStatus = {
  HOME: "HOME",
  CHAT: "CHAT",
  CHATS: "CHATS",
  SETTINGS: "SETTINGS",
  PROFILE: "PROFILE",
} as const;

type HomeScreenStatus = typeof HomeScreenStatus[keyof typeof HomeScreenStatus];

export interface HomeSliceState {
  status: HomeScreenStatus;
  loading: boolean;
  user: UserModelResponse | null;
}

const initialState: HomeSliceState = {
  status: HomeScreenStatus.HOME,
  loading: false,
  user: null,
};

export const initHome = (loading?: boolean): AppThunk => async (dispatch, getState) => {
  try {
    if (loading) return
    const user = await UserRequests.getCurrentUser();
    dispatch(setState({loading: true, user: user}));
  } catch (error) {
    dispatch(setUser(null));
  }
};

export const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    setState: (state, action: PayloadAction<Partial<HomeSliceState>>) => {
      state.status = action.payload.status ?? state.status;
      state.user = action.payload.user ?? state.user;
      state.loading = action.payload.loading ?? state.loading;
    },
    setUser: (state, action: PayloadAction<UserModelResponse | null>) => {
      state.user = action.payload;
    },
  },
});

export const {setState, setUser} = homeSlice.actions;
export const selectHomeStatus = (state: { home: HomeSliceState }) => state.home.status;
export const selectUser = (state: { home: HomeSliceState }) => state.home.user;
export const selectLoading = (state: { home: HomeSliceState }) => state.home.loading;

export default homeSlice.reducer;